import type { IconSvgObject } from './types';

const ChevronsRightLeftIcon: IconSvgObject = [
  ["path", { d: "M20 17C20 17 15 13.3176 15 12C15 10.6824 20 7 20 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.00004 17C4.00004 17 8.99999 13.3176 9 12C9.00001 10.6824 4 7 4 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsRightLeftIcon;
